import {useContext} from 'react';
import {useStateMachine} from 'little-state-machine';
import clearVessel from 'components/forms/reducers/clearVessel';
import {FormState} from 'components/forms/context';
import {LoopContext} from 'components/forms/context';

export function useClearVessel(nodeOverride) {
    const {node} = useContext(FormState);
    const looper = useContext(LoopContext);
    const loopNode = looper?.loopNode || '';

    const {actions} = useStateMachine({
        update: clearVessel(nodeOverride || node, loopNode),
    });

    return {
        clearAndUpdate: actions.update,
    };
}
